import { Checkbox, Stack } from '@fluentui/react';

import { FormVariables } from '../slice/newFormReducers';

export default (props: { formVariables: FormVariables }) => {
  return (
    <Stack horizontal tokens={{ childrenGap: 15 }}>
      {props.formVariables.isSpecialOrder && (
        <Checkbox checked={true} label="Özel Sipariş" />
      )}
    </Stack>
  );
};
